import { Controller } from '@hotwired/stimulus'

export default class ListmakerController extends Controller {
    static targets = ['listmaker', 'age', 'filter'];
    static filters = {};

    filterClick(e) {
        e.preventDefault();

        const isMobile = window.innerWidth < parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bp-desktop'));

        if (isMobile && this.hasAgeTarget && !this.ageTarget.classList.contains('show') && this.ageTarget.contains(e.target)) {
            return;
        }

        const filter = e.currentTarget;
        const isActive = filter.classList.contains('active');
        const parentListItem =  e.currentTarget.closest('li.submenu');
        const group = parentListItem?.dataset.value ?? 'unknown';

        // Remove active filter from current parentListItem's descendants
        parentListItem.querySelectorAll('.active').forEach((filter) => {
            filter.classList.remove('active');
        });

        // Remove .hide from the listmaker items
        this.listmakerTargets.forEach((listmaker) => {
            listmaker.classList.remove('hide');
        });

        // Update filtering values
        if (isActive) {
            ListmakerController.filters[group] = null;
        } else {
            ListmakerController.filters[group] = filter.dataset.value;
            filter.classList.add('active');
        }

        let filters = Object.keys(ListmakerController.filters)
            .filter((k) => ListmakerController.filters[k] != null)
            .reduce((a, k) => ({ ...a, [k]: ListmakerController.filters[k] }), {})
        ;

        if (0 === Object.values(filters).length) {
            return;
        }

        this.listmakerTargets.forEach((listmaker) => {
            listmaker.classList.add('hide');

            let hasAllCategories = true;

            Object.values(filters).forEach((value) => {
                if (!listmaker.dataset.categories.split(',').includes(value)) {
                    hasAllCategories = false;
                }
            });

            if (hasAllCategories) {
                listmaker.classList.remove('hide');
            }
        });
    }

    showAge(e) {
        if (e.currentTarget.classList.contains('show')) {
            e.preventDefault();

            return false;
        }

        e.currentTarget.classList.add('show');
    }

    documentClick(e) {
        if (!this.hasAgeTarget || this.ageTarget.contains(e.target)) {
            return;
        }

        this.ageTarget.classList.remove('show');
    }
}
